module.exports = "/images/waste-bin.svg?ea5959cfafb8333ee11fabd1d4d1e7dc";